import React, { Component } from 'react'
import CheckIcon from '../../production/partials/icons/check'
import EnvelopeIcon from '../../production/partials/icons/envelope'
import OrderIcon from '../../production/partials/icons/order'
import BellIcon from '../../production/partials/icons/bell'
import StopIcon from '../../production/partials/icons/stop'

class DashboardTodoRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: false
        };
    }

    handleOrderClick = (id, params, type) => {
        if (type === 'default') {
            if (params !== '') {
                window.open(`cost-estimates/${ id }${ params }`, '_blank');
            } else {
                window.open(`cost-estimates/${ id }`, '_blank');
            }
        } else if (type === 'message') {
            window.open(`/cost-estimates/${ id }/showMessages`, 'winMessages', 'menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=800,height=550');
        }
    }

    render() {
        const {
            id,
            icon,
            important,
            costEstimateId,
            customer,
            name,
            status
        } = this.props.data
        let view = null        
        
        if (!this.state.hidden) {
            let statusClass = ''
            let statusIcon = null
            let statusIconTitle = null
            let statusIconTitleStatus = null
            let queryParam = ''
            let linkType = 'default'

            /**
             * Order - Status code
             * 
             * Green = Klar (2)
             * Blue = Ej påbörjad (0)
             * Yellow = Påbörjad (1)
             * Orange = Försenad (3)
             * * Orange = Ej levererad (4)
             */        

            if (status === 0) {
                statusClass = 'not-started'
                statusIconTitleStatus = 'Ej påbörjad'
            } else if (status === 1) {
                statusClass = 'started'
                statusIconTitleStatus = 'Pågående'
            } else if (status === 2) {
                statusClass = 'done'
                statusIconTitleStatus = 'Leveransklar'
            } else if (status === 3) {
                statusClass = 'late'
                statusIconTitleStatus = 'Försenad'
            } else if (status === 4) {
                statusClass = 'not-delivered'
            } else {
                statusClass = 'default'
            }

            if (icon === 'order-confirm') {
                queryParam = '/order'
                statusIcon = <CheckIcon />
                statusIconTitle = 'Offert accepterad'
                statusClass = 'new'
            } else if (icon === 'order-done') {
                queryParam = '/delivery'
                statusIcon = <OrderIcon />
                statusIconTitle = 'Order'
            } else if (icon === 'order-message') {
                linkType = 'message'
                statusIcon = <EnvelopeIcon />
                statusIconTitle = 'Meddelande'
            } else if (icon === 'tender') {
                queryParam = `?dismissNotification=${ id }`
                statusClass = 'reminder'
                statusIcon = <BellIcon />
                statusIconTitle = 'Påminnelse'
            } else if (icon === 'tender-declined') {
                linkType = 'message'
                statusIcon = <StopIcon />
            }
            
            view = <li className={ `todo__inner__list__row todo__inner__list__row--${ statusClass }` }>
                <span className="todo__inner__list__row__item todo__inner__list__row__item__type" title={ `${ statusIconTitle } - ${ statusIconTitleStatus }` }>{ statusIcon }</span>
                <span className={ `todo__inner__list__row__item ${ important ? 'todo__inner__list__row__item--important' : 'todo__inner__list__row__item--important todo__inner__list__row__item--hide' }` } title="1 dag eller äldre"></span>
                <span className="todo__inner__list__row__item todo__inner__list__row__item--txt todo__inner__list__row__item--link" title={ customer } onClick={ this.handleOrderClick.bind(this, costEstimateId, queryParam, linkType) }>{ customer }</span>
                <span className="todo__inner__list__row__item todo__inner__list__row__item--txt todo__inner__list__row__item--link" onClick={ this.handleOrderClick.bind(this, costEstimateId, queryParam, linkType) } title={ name }>
                    { name }
                </span>
            </li>
        }

        return view
    }
}

export default DashboardTodoRow;
